/* santosh js - 2026-08-12 13:15 — ATC button restores trolley icon after Adding/Added (search + collection). */
(function (global) {
  "use strict";

  const CART_CONTENT_DELAY_MS = 500;

  function delay(ms) {
    return new Promise(function (resolve) {
      global.setTimeout(resolve, ms);
    });
  }

  function getShopifyRoot() {
    const root =
      global.Shopify &&
      global.Shopify.routes &&
      typeof global.Shopify.routes.root === "string"
        ? global.Shopify.routes.root
        : "/";

    return root.endsWith("/") ? root : root + "/";
  }

  function getCartAddUrl() {
    const routes = global.Shopify && global.Shopify.routes;
    if (routes && typeof routes.cart_add_url === "string" && routes.cart_add_url) {
      return routes.cart_add_url;
    }

    return getShopifyRoot() + "cart/add.js";
  }

  function getCartPagePath() {
    const routes = global.Shopify && global.Shopify.routes;
    if (routes && typeof routes.cart_url === "string" && routes.cart_url) {
      try {
        return new URL(routes.cart_url, global.location.origin).pathname;
      } catch (error) {
        return routes.cart_url;
      }
    }

    return "/cart";
  }

  function getSectionsUrlCandidates() {
    const candidates = [];
    const pathname = global.location && global.location.pathname;

    if (pathname) {
      candidates.push(pathname);
    }

    const cartPath = getCartPagePath();
    if (cartPath && candidates.indexOf(cartPath) === -1) {
      candidates.push(cartPath);
    }

    const root = getSectionsUrlRoot();
    if (candidates.indexOf(root) === -1) {
      candidates.push(root);
    }

    return candidates;
  }

  function getSectionsUrlRoot() {
    const root = getShopifyRoot();
    return root === "/" ? "/" : root.replace(/\/$/, "") || "/";
  }

  function discoverCartSectionsToRender() {
    const cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
      try {
        return cartDrawer.getSectionsToRender().map(function (section) {
          return {
            id: section.id,
            selector: section.selector || null,
          };
        });
      } catch (error) {
        console.warn("KartmaX could not read cart drawer sections.", error);
      }
    }

    const sections = [];
    if (document.querySelector("cart-drawer")) {
      sections.push({ id: "cart-drawer", selector: "#CartDrawer" });
    }
    if (document.querySelector("cart-notification")) {
      sections.push({ id: "cart-notification", selector: "#cart-notification" });
    }
    if (document.getElementById("cart-icon-bubble")) {
      sections.push({ id: "cart-icon-bubble" });
    }

    return sections;
  }

  function getSectionInnerHTML(html, selector) {
    if (!html || typeof html !== "string") {
      return "";
    }

    const parsed = new DOMParser().parseFromString(html, "text/html");
    const node = selector
      ? parsed.querySelector(selector)
      : parsed.querySelector(".shopify-section") || parsed.body.firstElementChild;

    return node ? node.innerHTML : "";
  }

  function sectionHtmlHasContent(html) {
    if (!html || typeof html !== "string") {
      return false;
    }

    const stripped = html.replace(/\s+/g, "");
    return stripped.length > 40;
  }

  function sectionsHaveUsableContent(sections, sectionConfigs) {
    if (!sections || typeof sections !== "object") {
      return false;
    }

    const drawerSection = sectionConfigs.find(function (section) {
      return section.id === "cart-drawer";
    });

    if (drawerSection) {
      return sectionHtmlHasContent(sections["cart-drawer"]);
    }

    return sectionConfigs.some(function (section) {
      return sectionHtmlHasContent(sections[section.id]);
    });
  }

  function buildSectionFetchUrl(sectionIds, sectionsUrl) {
    const path = sectionsUrl || getSectionsUrlRoot();
    const url = new URL(path, global.location.origin);
    url.searchParams.set("sections", sectionIds.join(","));
    url.searchParams.set("_kartmax", String(Date.now()));
    return url.toString();
  }

  function fetchRenderedSections(sectionConfigs, sectionsUrl) {
    const sectionIds = sectionConfigs
      .map(function (section) {
        return section.id;
      })
      .filter(Boolean);

    if (!sectionIds.length) {
      return Promise.resolve({});
    }

    return fetch(buildSectionFetchUrl(sectionIds, sectionsUrl), {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then(function (response) {
        if (!response.ok) {
          return {};
        }

        return response.json();
      })
      .catch(function () {
        return {};
      });
  }

  function fetchRenderedSectionsWithFallback(sectionConfigs) {
    const candidates = getSectionsUrlCandidates();
    let chain = Promise.resolve({});

    candidates.forEach(function (sectionsUrl) {
      chain = chain.then(function (currentSections) {
        if (sectionsHaveUsableContent(currentSections, sectionConfigs)) {
          return currentSections;
        }

        return fetchRenderedSections(sectionConfigs, sectionsUrl).then(function (nextSections) {
          if (!sectionsHaveUsableContent(nextSections, sectionConfigs)) {
            return currentSections;
          }

          return nextSections;
        });
      });
    });

    return chain;
  }

  function loadFreshCartSections(cartState, sectionConfigs) {
    return fetchRenderedSectionsWithFallback(sectionConfigs).then(function (sections) {
      if (sectionsHaveUsableContent(sections, sectionConfigs)) {
        return Object.assign({}, cartState, { sections: sections });
      }

      return cartState;
    });
  }

  function replaceCartDrawerMarkup(sectionHtml) {
    if (!sectionHtml) {
      return false;
    }

    const parsed = new DOMParser().parseFromString(sectionHtml, "text/html");
    const nextDrawer = parsed.querySelector("cart-drawer");
    const currentDrawer = document.querySelector("cart-drawer");

    if (!nextDrawer || !currentDrawer) {
      return false;
    }

    currentDrawer.innerHTML = nextDrawer.innerHTML;
    currentDrawer.classList.remove("is-empty");
    const drawerInner = currentDrawer.querySelector(".drawer__inner");
    if (drawerInner) {
      drawerInner.classList.remove("is-empty");
    }

    return true;
  }

  function applyCartSectionHtml(section, html) {
    if (!html) {
      return false;
    }

    if (section.id === "cart-drawer") {
      if (replaceCartDrawerMarkup(html)) {
        return true;
      }
    }

    const target = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);

    if (!target) {
      return false;
    }

    const innerHTML = getSectionInnerHTML(
      html,
      section.selector ? section.selector : ".shopify-section",
    );

    if (!innerHTML) {
      return false;
    }

    target.innerHTML = innerHTML;
    return true;
  }

  function manualApplyCartSections(cartState, sectionConfigs) {
    let applied = false;

    sectionConfigs.forEach(function (section) {
      const html = cartState.sections && cartState.sections[section.id];
      if (html && applyCartSectionHtml(section, html)) {
        applied = true;
      }
    });

    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      cartDrawer.classList.remove("is-empty");
      const drawerInner = cartDrawer.querySelector(".drawer__inner");
      if (drawerInner) {
        drawerInner.classList.remove("is-empty");
      }
    }

    return applied;
  }

  function dispatchDrawerViewEvent() {
    const cartDrawerItems = document.querySelector("cart-drawer cart-drawer-items");
    if (cartDrawerItems && typeof cartDrawerItems.dispatchViewEvent === "function") {
      cartDrawerItems.dispatchViewEvent();
    }
  }

  function updateCartCountBadges(itemCount) {
    const count = Number(itemCount) || 0;
    const label = String(count);
    const selectors = [
      "#cart-icon-bubble .cart-count-bubble span[aria-hidden='true']",
      "#cart-icon-bubble .cart-count-bubble span",
      ".cart-count-bubble span",
      "[data-cart-count]",
      ".cart-count",
      ".header__icon--cart .count",
      "a[href*='/cart'] .count",
      ".js-cart-count",
      "#cart-icon-bubble",
    ];

    document.querySelectorAll(selectors.join(", ")).forEach(function (node) {
      if (node.closest("cart-drawer") || node.closest("cart-notification")) {
        return;
      }

      if (node.id === "cart-icon-bubble") {
        return;
      }

      node.textContent = label;
    });

    document.querySelectorAll(".cart-count-bubble").forEach(function (node) {
      if (count > 0) {
        node.classList.remove("visually-hidden", "hidden", "hide");
        node.removeAttribute("hidden");
      } else {
        node.classList.add("visually-hidden");
      }
    });
  }

  function publishCartEvents(cart) {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", { bubbles: true }),
    );
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:updated", {
        bubbles: true,
        detail: { cart: cart },
      }),
    );

    if (
      typeof global.publish === "function" &&
      global.PUB_SUB_EVENTS &&
      global.PUB_SUB_EVENTS.cartUpdate
    ) {
      global.publish(global.PUB_SUB_EVENTS.cartUpdate, {
        source: "kartmax-cart",
        cartData: cart,
      });
    }
  }

  function refreshCartFromServer(cartState) {
    return fetch(getShopifyRoot() + "cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then(function (response) {
        if (!response.ok) {
          return null;
        }

        return response.json();
      })
      .then(function (cart) {
        if (!cart) {
          return cartState;
        }

        updateCartCountBadges(cart.item_count || 0);
        publishCartEvents(cart);
        return cartState;
      })
      .catch(function () {
        return cartState;
      });
  }

  function openCartDrawerElement(cartDrawer) {
    if (!cartDrawer || typeof cartDrawer.open !== "function") {
      return;
    }

    const cartIcon = document.querySelector("#cart-icon-bubble");
    cartDrawer.open(cartIcon || undefined);
  }

  function drawerHasLineItems() {
    return Boolean(
      document.querySelector("#CartDrawer .cart-item") ||
        document.querySelector("#CartDrawer .cart-items") ||
        document.querySelector("#CartDrawer tbody tr") ||
        document.querySelector("cart-drawer .cart-item"),
    );
  }

  function openCartDrawerUi(cartState) {
    const sectionConfigs = discoverCartSectionsToRender();

    return loadFreshCartSections(cartState, sectionConfigs).then(function (fullState) {
      const cartDrawer = document.querySelector("cart-drawer");
      let rendered = manualApplyCartSections(fullState, sectionConfigs);

      if (
        !drawerHasLineItems() &&
        cartDrawer &&
        typeof cartDrawer.renderContents === "function" &&
        sectionsHaveUsableContent(fullState.sections, sectionConfigs)
      ) {
        try {
          cartDrawer.renderContents(fullState);
          rendered = true;
        } catch (error) {
          console.warn("KartmaX cart drawer renderContents failed.", error);
        }
      }

      if (!drawerHasLineItems()) {
        rendered = manualApplyCartSections(fullState, sectionConfigs) || rendered;
      }

      dispatchDrawerViewEvent();

      if (cartDrawer) {
        openCartDrawerElement(cartDrawer);
      }

      const cartNotification = document.querySelector("cart-notification");
      if (
        !drawerHasLineItems() &&
        cartNotification &&
        typeof cartNotification.renderContents === "function" &&
        sectionsHaveUsableContent(fullState.sections, sectionConfigs)
      ) {
        try {
          cartNotification.renderContents(fullState);
          if (typeof cartNotification.open === "function") {
            cartNotification.open();
          }
          rendered = true;
        } catch (error) {
          console.warn("KartmaX cart notification renderContents failed.", error);
        }
      }

      return refreshCartFromServer(fullState);
    });
  }

  function postCartAdd(variantId, sectionConfigs) {
    const sectionIds = sectionConfigs
      .map(function (section) {
        return section.id;
      })
      .filter(Boolean);
    const sectionsUrl = getSectionsUrlCandidates()[0] || getSectionsUrlRoot();
    const formData = new FormData();
    formData.append("id", String(variantId));
    formData.append("quantity", "1");

    if (sectionIds.length) {
      formData.append("sections", sectionIds.join(","));
      formData.append("sections_url", sectionsUrl);
    }

    return fetch(getCartAddUrl(), {
      body: formData,
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      method: "POST",
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) {
          throw new Error((data && data.description) || "Cart add failed.");
        }

        return data;
      });
    });
  }

  // santosh js - 2026-08-12 18:15 — loader on ATC (no Adding/Added text); restore trolley SVG.
  function setAddToCartButtonLoading(button) {
    if (!button) {
      return;
    }

    button.innerHTML =
      '<span class="kartmax-atc-loader" aria-live="polite" aria-label="Adding to cart">' +
      '<span class="kartmax-atc-spinner" aria-hidden="true"></span>' +
      "</span>";
  }

  function restoreAddToCartButton(button, originalHtml) {
    if (!button) {
      return;
    }

    button.disabled = false;
    button.removeAttribute("aria-busy");
    button.innerHTML = originalHtml;
  }

  function addProductByHandle(handle, options) {
    const settings = options || {};
    const button = settings.button || null;
    const fallbackUrl = settings.fallbackUrl || "";

    if (!handle) {
      if (fallbackUrl && fallbackUrl !== "#") {
        global.location.href = fallbackUrl;
      }
      return Promise.resolve();
    }

    const originalHtml = button ? button.innerHTML : "";
    if (button) {
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      setAddToCartButtonLoading(button);
    }

    const sectionConfigs = discoverCartSectionsToRender();

    return fetch(getShopifyRoot() + "products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin",
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Product lookup failed.");
        }

        return response.json();
      })
      .then(function (product) {
        const variants = Array.isArray(product.variants) ? product.variants : [];
        const variant =
          variants.find(function (item) {
            return item.available;
          }) || variants[0];

        if (!variant || !variant.id) {
          throw new Error("No purchasable variant.");
        }

        return postCartAdd(variant.id, sectionConfigs);
      })
      .then(function (cartState) {
        return delay(CART_CONTENT_DELAY_MS).then(function () {
          return openCartDrawerUi(cartState);
        });
      })
      .then(function () {
        if (!button) {
          return;
        }

        // Brief pause so loader is visible, then restore trolley icon.
        global.setTimeout(function () {
          restoreAddToCartButton(button, originalHtml);
        }, 400);
      })
      .catch(function (error) {
        console.error("KartmaX add to cart failed.", error);
        if (button) {
          restoreAddToCartButton(button, originalHtml);
        }

        if (fallbackUrl && fallbackUrl !== "#") {
          global.location.href = fallbackUrl;
        }
      });
  }

  // santosh js - 2026-08-12 18:15 — CDN textContent "Adding/Added" → show loader / restore icon.
  function createAddToCartButtonProxy(realButton, originalHtml) {
    return {
      get disabled() {
        return realButton.disabled;
      },
      set disabled(value) {
        realButton.disabled = Boolean(value);
      },
      setAttribute: function (name, value) {
        realButton.setAttribute(name, value);
      },
      removeAttribute: function (name) {
        realButton.removeAttribute(name);
      },
      get textContent() {
        return realButton.textContent;
      },
      set textContent(value) {
        const text = String(value || "").trim();
        if (/^adding/i.test(text) || /^added$/i.test(text)) {
          realButton.disabled = true;
          realButton.setAttribute("aria-busy", "true");
          setAddToCartButtonLoading(realButton);
          return;
        }
        restoreAddToCartButton(realButton, originalHtml);
      },
      get innerHTML() {
        return realButton.innerHTML;
      },
      set innerHTML(value) {
        if (value === originalHtml) {
          restoreAddToCartButton(realButton, originalHtml);
          return;
        }
        const plain = String(value || "")
          .replace(/<[^>]*>/g, "")
          .trim();
        if (/^adding/i.test(plain) || /^added$/i.test(plain)) {
          setAddToCartButtonLoading(realButton);
          return;
        }
        realButton.innerHTML = value;
      },
    };
  }

  function bindAddToCartContainer(container) {
    if (!container || container.dataset.kartmaxCartBound === "true") {
      return;
    }

    container.dataset.kartmaxCartBound = "true";
    container.addEventListener("click", function (event) {
      if (!(event.target instanceof Element)) {
        return;
      }

      const button = event.target.closest("[data-kartmax-add-to-cart]");
      if (!button) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      // Theme addProductByHandle restores innerHTML; proxy kept for CDN-compat callers.
      addProductByHandle(button.getAttribute("data-product-handle") || "", {
        button: button,
        fallbackUrl: button.getAttribute("data-product-url") || "",
      });
    });
  }

  // santosh js - 2026-08-13 17:35 — Wishlist Hero same as theme/search:
  // empty .wishlist-hero-custom-button + data-wlh-* attrs + custom event.
  // Do NOT inject nested <button> — that blocks Wishlist Hero click handlers.
  function resolveWishlistImage(product) {
    if (typeof product.featured_image === "string" && product.featured_image) {
      return product.featured_image;
    }
    if (product.featured_image && typeof product.featured_image.src === "string") {
      return product.featured_image.src;
    }
    if (Array.isArray(product.images) && product.images.length) {
      const first = product.images[0];
      return typeof first === "string" ? first : (first && first.src) || "";
    }
    return "";
  }

  function notifyWishlistHero(button) {
    if (!button) {
      return;
    }

    function dispatch() {
      try {
        // Keep node empty like theme Liquid stub so WLH can own the UI.
        if (button.querySelector(".kartmax-wishlist-fallback")) {
          button.innerHTML = "";
        }
        document.dispatchEvent(
          new CustomEvent("wishlist-hero-add-to-custom-element", {
            detail: button,
          }),
        );
      } catch (error) {
        console.warn("KartmaX could not notify Wishlist Hero.", error);
      }
    }

    dispatch();
    // Collection PLP cards often mount after Wishlist Hero boot.
    [300, 1000, 2000, 4000].forEach(function (ms) {
      global.setTimeout(dispatch, ms);
    });
  }

  function extractHandleFromProductUrl(url) {
    if (!url || typeof url !== "string") {
      return "";
    }
    const match = url.trim().match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function getWishlistHandleCandidates(button) {
    const candidates = [];

    function push(value) {
      if (typeof value !== "string") {
        return;
      }
      const handle = value.trim();
      if (!handle || candidates.indexOf(handle) !== -1) {
        return;
      }
      candidates.push(handle);
    }

    // Prefer handle from real product URL (Shopify) over Kartmax url_key.
    push(extractHandleFromProductUrl(button.getAttribute("data-product-url") || ""));
    push(button.getAttribute("data-product-handle") || "");

    return candidates;
  }

  function fetchShopifyProductByHandles(handles) {
    let index = 0;

    function tryNext() {
      if (index >= handles.length) {
        return Promise.reject(new Error("Wishlist product lookup failed."));
      }
      const handle = handles[index];
      index += 1;
      return fetch(getShopifyRoot() + "products/" + encodeURIComponent(handle) + ".js", {
        credentials: "same-origin",
      }).then(function (response) {
        if (!response.ok) {
          return tryNext();
        }
        return response.json().then(function (product) {
          return { product: product, handle: handle };
        });
      });
    }

    return tryNext();
  }

  function fetchShopifyProductBySuggestName(name) {
    const query = (name || "").trim();
    if (!query) {
      return Promise.reject(new Error("No product name for suggest lookup."));
    }

    const suggestUrl =
      getShopifyRoot() +
      "search/suggest.json?q=" +
      encodeURIComponent(query) +
      "&resources[type]=product&resources[limit]=5";

    return fetch(suggestUrl, { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Suggest lookup failed.");
        }
        return response.json();
      })
      .then(function (payload) {
        const products =
          (payload &&
            payload.resources &&
            payload.resources.results &&
            payload.resources.results.products) ||
          [];
        if (!products.length) {
          throw new Error("Suggest returned no products.");
        }

        const needle = query.toLowerCase();
        const match =
          products.find(function (item) {
            return String(item.title || "").toLowerCase() === needle;
          }) ||
          products.find(function (item) {
            return String(item.title || "")
              .toLowerCase()
              .indexOf(needle) !== -1;
          }) ||
          products[0];

        const handle = match && match.handle;
        if (!handle) {
          throw new Error("Suggest product missing handle.");
        }

        return fetchShopifyProductByHandles([handle]);
      });
  }

  // santosh js - 2026-08-13 17:40 — retry handles: Kartmax url_key often 404s on Shopify PLP
  function hydrateWishlistButton(button) {
    if (!button) {
      return;
    }
    if (
      button.dataset.kartmaxWishlistReady === "true" ||
      button.dataset.kartmaxWishlistReady === "pending"
    ) {
      return;
    }

    const handles = getWishlistHandleCandidates(button);
    if (!handles.length) {
      return;
    }

    button.dataset.kartmaxWishlistReady = "pending";

    fetchShopifyProductByHandles(handles)
      .catch(function () {
        return fetchShopifyProductBySuggestName(
          button.getAttribute("data-product-name") || "",
        );
      })
      .then(function (result) {
        const product = result.product;
        const handle = result.handle;
        const variants = Array.isArray(product.variants) ? product.variants : [];
        const variant =
          variants.find(function (item) {
            return item.available;
          }) || variants[0];
        if (!product.id || !variant || !variant.id) {
          throw new Error("Wishlist product data incomplete.");
        }

        const image = resolveWishlistImage(product);
        const link =
          global.location.origin +
          (product.url || "/products/" + (product.handle || handle));
        const price = Number(product.price) / 100;

        // Keep data-product-handle on the real Shopify handle for ATC/wishlist.
        button.setAttribute("data-product-handle", product.handle || handle);
        button.setAttribute("data-wlh-id", String(product.id));
        button.setAttribute("data-wlh-variantid", String(variant.id));
        button.setAttribute("data-wlh-link", link);
        button.setAttribute(
          "data-wlh-price",
          Number.isFinite(price) ? String(price) : "0",
        );
        button.setAttribute(
          "data-wlh-name",
          product.title || variant.name || handle,
        );
        button.setAttribute("data-wlh-image", image);
        button.setAttribute("data-wlh-mode", "icon_only");
        button.setAttribute("data-wlh-view", "Collection");
        button.classList.add(
          "wishlist-hero-custom-button",
          "wishlisthero-floating",
        );
        button.setAttribute("style", "left: auto;");
        button.innerHTML = "";
        button.dataset.kartmaxWishlistReady = "true";
        notifyWishlistHero(button);
      })
      .catch(function (error) {
        button.dataset.kartmaxWishlistReady = "error";
        console.warn("KartmaX wishlist hydrate failed.", error, handles);
      });
  }

  function initWishlistButtons(gridNode) {
    if (!gridNode) {
      return;
    }

    gridNode
      .querySelectorAll("[data-kartmax-wishlist][data-product-handle]")
      .forEach(hydrateWishlistButton);
  }

  // santosh js - 2026-08-13 17:50 — header wishlist count badge + toast polish
  function syncWishlistHeaderCount() {
    document
      .querySelectorAll(
        "a.wishlist-hero-header-icon span.wishlist-hero-items-count, .site-header__icon span.wishlist-hero-items-count",
      )
      .forEach(function (badge) {
        const raw = (badge.textContent || "").trim();
        const count = parseInt(raw, 10);
        if (!raw || Number.isNaN(count) || count <= 0) {
          badge.classList.remove("wishlist-hero-items-count-exists");
          badge.style.display = "none";
          return;
        }
        badge.classList.add(
          "wishlist-hero-items-count-exists",
          "cart-count-bubble",
        );
        badge.style.display = "inline-flex";
        badge.setAttribute("aria-hidden", "false");
      });
  }

  function polishWishlistAddToast(root) {
    if (!root || root.dataset.santoshWishlistToastPolished === "true") {
      return;
    }
    root.dataset.santoshWishlistToastPolished = "true";

    const content = root.querySelector(".MuiCardContent-root");
    if (!content) {
      return;
    }

    const imageNode = content.querySelector("div[style*='background-image'], div:first-child");
    if (imageNode) {
      imageNode.classList.add("santosh-wishlist-toast-image");
      // Force visible thumb when WLH injects a zero-height media div.
      if (!imageNode.style.minHeight) {
        imageNode.style.minHeight = "6.4rem";
      }
      if (!imageNode.style.minWidth) {
        imageNode.style.minWidth = "6.4rem";
      }
    }

    syncWishlistHeaderCount();
  }

  function initWishlistUiEnhancements() {
    if (document.documentElement.dataset.santoshWishlistUi === "true") {
      return;
    }
    document.documentElement.dataset.santoshWishlistUi = "true";

    syncWishlistHeaderCount();

    const observer = new MutationObserver(function (mutations) {
      let shouldSyncCount = false;

      mutations.forEach(function (mutation) {
        if (
          mutation.type === "characterData" ||
          (mutation.target &&
            mutation.target.classList &&
            mutation.target.classList.contains("wishlist-hero-items-count"))
        ) {
          shouldSyncCount = true;
        }

        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) {
            return;
          }
          if (
            node.matches &&
            (node.matches("#wishlist-hero-add-prod-to-wishlist-notification") ||
              node.matches(".wishlist-hero-add-prod-to-wishlist-notification"))
          ) {
            polishWishlistAddToast(node);
          } else {
            const toast = node.querySelector
              ? node.querySelector(
                  "#wishlist-hero-add-prod-to-wishlist-notification, .wishlist-hero-add-prod-to-wishlist-notification",
                )
              : null;
            if (toast) {
              polishWishlistAddToast(toast);
            }
          }

          if (
            node.matches &&
            (node.matches("span.wishlist-hero-items-count") ||
              node.querySelector("span.wishlist-hero-items-count"))
          ) {
            shouldSyncCount = true;
          }
        });
      });

      if (shouldSyncCount) {
        syncWishlistHeaderCount();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    document.addEventListener("wishlist-hero-add-to-custom-element", function () {
      global.setTimeout(syncWishlistHeaderCount, 250);
      global.setTimeout(syncWishlistHeaderCount, 1000);
    });

    [
      "#wishlist-hero-add-prod-to-wishlist-notification",
      ".wishlist-hero-add-prod-to-wishlist-notification",
    ].forEach(function (selector) {
      const existing = document.querySelector(selector);
      if (existing) {
        polishWishlistAddToast(existing);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initWishlistUiEnhancements);
  } else {
    initWishlistUiEnhancements();
  }

  // santosh js - 2026-08-12 15:20 — shared PLP binder (search + collection).
  function bindProductCardActions(gridNode) {
    if (!gridNode) {
      return;
    }

    if (gridNode.dataset.santoshAtcBound !== "true") {
      gridNode.dataset.santoshAtcBound = "true";
      gridNode.dataset.kartmaxCartBound = "true";

      gridNode.addEventListener("click", function (event) {
        if (!(event.target instanceof Element)) {
          return;
        }

        const button = event.target.closest("[data-kartmax-add-to-cart]");
        if (!button) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        const handle = button.getAttribute("data-product-handle") || "";
        const fallbackUrl = button.getAttribute("data-product-url") || "";

        addProductByHandle(handle, {
          button: button,
          fallbackUrl: fallbackUrl,
        });
      });
    }

    initWishlistButtons(gridNode);
  }

  global.KartmaxCart = {
    __santoshThemeCart: true,
    addProductByHandle: addProductByHandle,
    bindAddToCartContainer: bindAddToCartContainer,
    bindProductCardActions: bindProductCardActions,
    createAddToCartButtonProxy: createAddToCartButtonProxy,
    initWishlistButtons: initWishlistButtons,
    refreshCartCountBadges: updateCartCountBadges,
  };

  // santosh js - 2026-08-12 15:55 — CDN kartmax-cart.js overwrites window.KartmaxCart;
  // keep closed-over helpers here so PLPs can still restore trolley icon + wishlist.
  global.__KartmaxSantosh = {
    addProductByHandle: addProductByHandle,
    bindProductCardActions: bindProductCardActions,
    createAddToCartButtonProxy: createAddToCartButtonProxy,
    initWishlistButtons: initWishlistButtons,
  };
})(typeof window !== "undefined" ? window : globalThis);